import { ConsumerAuthenticationDto } from '../types/consumerAuthenticationDto'
import { transactionApiClient, psd2ProxyApi } from './apis'
import { CreateBankSessionResponse } from '../types'

export async function authenticateConsumerWithInstructionId(
	instructionId: string,
): Promise<ConsumerAuthenticationDto> {
	try {
		const response = await transactionApiClient.get(
			`consumer-data-pull-sessions/authenticate-with-instruction-id/${instructionId}`,
		)

		return response.data
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}

export async function initiateTransactionDataFetchingWithJustKeyId(
	keyId: string,
): Promise<CreateBankSessionResponse> {
	try {
		return await transactionApiClient.timeout(false).post<any>(
			`consumer-data-pull-sessions/initiate-bank-session/${keyId}/bec`, // We should rename the endpoint at some point
			{},
		)
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}

export async function initiateTransactionDataFetching(
	keyId: string,
	code: string,
): Promise<CreateBankSessionResponse> {
	try {
		return await transactionApiClient
			.timeout(false)
			.post<any>(`consumer-data-pull-sessions/initiate-bank-session/${keyId}`, {
				code,
			})
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}

export async function initiateTransactionDataFetchingWithProxy(
	url: string,
	keyId: string,
	code: string,
): Promise<CreateBankSessionResponse> {
	try {
		if (url.includes("monthioClientRedirect=true")) {
			const urlObject = new URL(url)
			const searchParams = urlObject.searchParams
			searchParams.append("keyId", keyId)
			searchParams.append("code", code)
			urlObject.search = searchParams.toString()

			window.location.replace(urlObject.toString())
			return Promise.reject()
		}

		const apiClient = psd2ProxyApi(url)

		return await apiClient
			.timeout(false)
			.post<any>(`consumer-data-pull-sessions/initiate-bank-session/${keyId}`, {
				code,
			})
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}

export type HandleOauthRedirectWithErrorRequestDto = {
	error: string
	errorDescription?: string
	errorUri?: string
}

export async function handleOauth2RedirectError(
	keyId: string,
	input: HandleOauthRedirectWithErrorRequestDto,
): Promise<CreateBankSessionResponse> {
	try {
		return await transactionApiClient
			.timeout(false)
			.post<any>(
				`consumer-data-pull-sessions/handle-redirect-failure/${keyId}`,
				{
					...input,
				},
			)
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}

export async function handleOauth2RedirectErrorWithProxy(
	url: string,
	keyId: string,
	input: HandleOauthRedirectWithErrorRequestDto,
): Promise<CreateBankSessionResponse> {
	try {
		const apiClient = psd2ProxyApi(url)

		return await apiClient
			.timeout(false)
			.post<any>(
				`consumer-data-pull-sessions/handle-redirect-failure/${keyId}`,
				{
					...input,
				},
			)
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}